<template>
  <Content
    class="col-span-full"
    :title="$route.name"
    type="list"
    :pagination="{
      count: tableData.count,
      current: +$route.query.p,
      request: 'drivers/',
      search: search,
    }"
    @tableData="tableData = $event"
    @loading="loading = $event"
  >
    <customDialog
      customWidth="60%"
      v-if="behaviourDialog"
      :title="$t('DAILY_REPORT_BHV_DRIVER')"
      childClass="info_msg"
      :show="behaviourDialog"
      @show="behaviourDialog = $event"
      @close="closedBhvModal"
      @confirmButn="submitBhv"
      form="true"
    >
      <el-form
        status-icon
        :model="BhvDriver"
        label-position="top"
        ref="BhvDriver"
        v-loading="bhvLoading"
        label-width="120px"
        class="demo-ruleForm grid grid-cols-2 gap-4 status-icon"
      >
        <el-form-item
          :label="$t('DATE_')"
          prop="date"
          :rules="{
            required: true,
            message: $t('REQUIRED_FIELD', {
              type: $t('DATE_'),
            }),
            trigger: 'blur',
          }"
        >
          <date-picker
            color="#151515"
            class="el-input__inner"
            v-model="BhvDriver.date"
            format="jYYYY-jMM-jDD"
            clearable
            :max="maxDate"
            :locale="$i18n.locale"
          />
        </el-form-item>

        <template v-slot:footerConfirm>
          <el-button type="success" @click="submitForm('BhvDriver')">
            {{ $t('SUBMIT') }}
          </el-button>
        </template>
      </el-form>
      <div
        v-show="bhvResult"
        class="grid items-center lg:grid-cols-4 gap-4 mt-4 lg:items-center"
      >
        <div
          class="col-span-full grid"
          :class="{
            'lg:grid-cols-2':
              bhvResult &&
              (bhvResult.number_of_harsh_acceleration ||
                bhvResult.number_of_harsh_braking ||
                bhvResult.number_of_harsh_cornering),
          }"
        >
          <div
            class="grid gap-4"
            :class="{
              'lg:grid-cols-2':
                bhvResult &&
                (bhvResult.number_of_harsh_acceleration ||
                  bhvResult.number_of_harsh_braking ||
                  bhvResult.number_of_harsh_cornering),

              'lg:grid-cols-4':
                bhvResult &&
                !(
                  bhvResult.number_of_harsh_acceleration ||
                  bhvResult.number_of_harsh_braking ||
                  bhvResult.number_of_harsh_cornering
                ),
            }"
          >
            <Service
              :title="`${$t('Amount_of_work')}`"
              :customType="$t('HOUR')"
              :summary="bhvResult && calculateHour(bhvResult.work_time)"
            />

            <Service
              :title="$t('distance_traveled')"
              :customType="$t('km')"
              :summary="bhvResult && (bhvResult.length / 1000).toFixed(1)"
            />

            <Service
              :title="$t('MAX_SPEED')"
              :customType="$t('KM_H')"
              :summary="bhvResult && bhvResult.max_speed"
            />

            <Service
              :title="$t('AVG_SPEED')"
              :customType="$t('KM_H')"
              :summary="bhvResult && bhvResult.mean_speed"
            />
          </div>
          <VueApexCharts
            v-if="
              bhvResult &&
              (bhvResult.number_of_harsh_acceleration ||
                bhvResult.number_of_harsh_braking ||
                bhvResult.number_of_harsh_cornering)
            "
            type="pie"
            :options="{
              chartOptions,
              labels: [
                $t('number_of_harsh_acceleration'),
                $t('number_of_harsh_braking'),
                $t('number_of_harsh_cornering'),
              ],
            }"
            :series="[
              bhvResult.number_of_harsh_acceleration,
              bhvResult.number_of_harsh_braking,
              bhvResult.number_of_harsh_cornering,
            ]"
          ></VueApexCharts>
        </div>
      </div>
    </customDialog>

    <tableSearch
      @search="searchDriver"
      :searchValue="search"
      :placeholder="
        $t('SEARCH_FOR', {
          type: $t('FULL_NAME'),
        })
      "
    />
    <el-table
      :empty-text="$t('NO_DATA')"
      :data="tableData.results"
      v-loading="loading"
      :stripe="true"
      :default-sort="{ prop: 'id', order: 'descending' }"
      style="width: 100%"
    >
      <el-table-column
        sortable
        type="index"
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="$t('INDEX')"
        width="60"
      >
        <template slot-scope="scope">
          <div :data-title="$t('INDEX')">
            {{ scope.$index + 1 }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="$t('FULL_NAME')"
        width="180"
      >
        <template slot-scope="scope">
          <div :data-title="$t('FULL_NAME')">
            {{ scope.row.first_name + ' ' + scope.row.last_name }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="$t('BIRTHDAY')"
        width="120"
      >
        <template slot-scope="scope">
          <div :data-title="$t('BIRTHDAY')">
            <span v-if="$i18n.locale == 'fa'">
              {{ scope.row.birthdate | getPersianDate }}
            </span>
            <span v-else>
              {{ scope.row.birthdate }}
            </span>
          </div>
        </template>
      </el-table-column>

      <el-table-column
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="$t('MOBILE')"
        width="180"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.mobile" :data-title="$t('MOBILE')">
            <a
              class="text-blue-500 hover:text-blue-700"
              :href="'tel:+98' + scope.row.mobile"
            >
              {{ '0' + scope.row.mobile }}
            </a>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="national_id"
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="$t('NATIONAL_CODE')"
        width="120"
      >
        <template slot-scope="scope">
          <div :data-title="$t('NATIONAL_CODE')">
            {{ scope.row.national_id }}
          </div>
        </template>
      </el-table-column>

      <!-- <el-table-column sortable :sort-method="sorttWork" :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="$t('WORKING_STATUS')" width="160">
        <template slot-scope="scope">
          <div :data-title="$t('WORKING_STATUS')">
            <StatusHolder v-if="scope.row.status" :status="scope.row.status" />
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="employee_id" sortable :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="$t('PERSONNEL_CODE')" width="160">
        <template slot-scope="scope">
          <div :data-title="$t('PERSONNEL_CODE')">
            {{ scope.row.employee_id }}
          </div>
        </template>
      </el-table-column> -->

      <el-table-column label="" width="190">
        <template slot-scope="scope">
          <div class="fixed-column">
            <tableFeatures
              :description="scope.row.description"
              :router="{
                name: 'EDIT_DRIVER',
                id: scope.row.id,
              }"
              :isDeleteable="false"
              :title="$t('DRIVER_TITLE')"
              @open="open($event)"
              @view="view($event, 'VIEW_DRIVER')"
              :view="true"
            >
              <el-tooltip
                class="item"
                effect="dark"
                :content="$t('DAILY_REPORT_BHV_DRIVER')"
                placement="bottom"
              >
                <img
                  @click="
                    behaviourDialog = true
                    selectedDriver = scope.row.id
                  "
                  class="inline-block w-5 cursor-pointer"
                  :src="require(`@/assets/images/report.png`)"
                  alt=""
                />
              </el-tooltip>
              <setOrg
                :organizationsId="scope.row.organizations"
                :id="scope.row.id"
                type="driver"
              />
            </tableFeatures>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </Content>
</template>

<script>
import { driverList, removeDriver, behavioursDrivers } from '@/api/drivers'
import VueApexCharts from 'vue-apexcharts'
import { resetForm } from '@/mixins/resetForm'
import tableSearch from '@/components/elements/tableSearch'
import tableFeatures from '@/components/elements/tableFeatures'
import customDialog from '@/components/elements/dialog'
import setOrg from '@/components/elements/set-org'
import { jalaliToGregorian } from '@/mixins/jalaliToGregorian'
import { gregorianToJalali } from '@/mixins/gregorianToJalali'
import Service from '@/pages/home/service'
// import StatusHolder from "@/components/elements/statusHolder";
import { open } from '@/mixins/openDesc'
import { view } from '@/mixins/viewPage'
import { calculateHour } from '@/mixins/calculateHour'

export default {
  mixins: [
    open,
    view,
    jalaliToGregorian,
    gregorianToJalali,
    calculateHour,
    resetForm,
  ],
  data() {
    return {
      tableData: {
        results: [],
      },
      chartOptions: {
        chart: {
          width: 380,
          type: 'pie',
          locales: ['fa'],
          defaultLocale: 'fa',
          type: 'line',
          id: 'areachart-2',
          fontFamily: 'Vazir',
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: 'bottom',
              },
            },
          },
        ],
      },
      search: '',
      loading: true,
      bhvResult: null,
      behaviourDialog: false,
      selectedDriver: null,
      selectedOrg: null,
      bhvLoading: false,
      driverStatus: [
        {
          id: null,
          en_title: '',
          fa_title: '',
          color_code: '',
        },
      ],
      BhvDriver: {
        date: '',
      },
    }
  },

  methods: {
    sorttWork(a, b) {
      if (a.working < b.working) return -1
      if (a.working > b.working) return 1
      return 0
    },
    searchDriver(val) {
      this.search = val
      const query = { ...this.$route.query, search: this.search }
      if (this.$route.query.p) delete query.p // Remove 'p' if it exists
      this.$router.replace({ query })

      this.tableData = []
      this.loading = true
      driverList.api(val).then((res) => {
        if (res) {
          this.tableData = res
          this.loading = false
        }
      })
    },
    remove(id) {
      removeDriver.api(id).then((res) => {
        if (res) {
          this.$notify({
            title: this.$i18n.t('SOMETHING_DELETED', {
              type: this.$i18n.t('DRIVER_TITLE'),
            }),
            duration: 4000,
            customClass: 'info_msg',
          })
          this.tableData.results = this.tableData.results.filter(
            (table) => table.id !== id
          )
        }
      })
    },
    submitBhv() {
      this.$refs['BhvDriver'].validate((valid) => {
        if (valid) {
          this.bhvLoading = true
          this.bhvResult = null
          const actionPayload = [
            this.selectedDriver,
            this.jalaliToGregorian(this.BhvDriver.date, this.$i18n.locale),
          ]

          behavioursDrivers.api(actionPayload).then((res) => {
            this.bhvLoading = false
            if (res) {
              this.bhvResult = res
            } else {
              this.$notify.error({
                title: this.$i18n.t('NO_DATA', {
                  type: this.$i18n.t('Add_fuel_transaction'),
                }),
                duration: 5000,
                customClass: 'error_msg',
              })
            }
          })
        } else {
          this.$notify.error({
            title: this.$i18n.t('FIXED_ERRORS', {
              type: this.$i18n.t('Add_fuel_transaction'),
            }),
            duration: 5000,
            customClass: 'error_msg',
          })
          return false
        }
      })
    },
    closedBhvModal() {
      this.behaviourDialog = false
      this.bhvResult = null
      this.resetForm('BhvDriver')
    },
  },
  mounted() {
    const { search } = this.$route.query

    // Initialize search and selectedTag
    this.search = search || ''

    driverList.api(this.search).then((res) => {
      if (res) {
        this.tableData = res
      }
      this.loading = false
    })
  },
  components: {
    tableSearch,
    tableFeatures,
    customDialog,
    Service,
    VueApexCharts,
    setOrg,
    // StatusHolder,
  },
  computed: {
    maxDate() {
      let todayDate = new Date()
        .toLocaleDateString('en-us')
        .replaceAll('/', '-')
        .split('-')
      todayDate = `${todayDate[2]}-${todayDate[0]}-${todayDate[1]}`
      return this.gregorianToJalali(todayDate, 'fa')
    },
  },
}
</script>
